import { NSARouterMakerResult } from 'namirasoft-account-react';
import { ContainerRegistryRow, ContainerRegistryType } from 'namirasoft-container-registry';
import { NamingConvention } from 'namirasoft-core';
import { AWSRow, AzureRow, BasicAuthRow, GCPRow, GitHubRow, GitLabRow } from 'namirasoft-credential';
import { NamirasoftMap } from 'namirasoft-site-map';
import { NSBox, NSBoxEntity, NSBoxEnum, NSBoxString, NSBoxTextArea, NSColumn, NSRow } from 'namirasoft-site-react';
import { Component, createRef } from 'react';
import { ContainerRegistryEntities } from '../ContainerRegistryEntities';
import { ContainerRegistryLayout } from '../ContainerRegistryLayout';
import { ContainerRegistryRouterProps } from '../ContainerRegistryRouterProps';
export interface ContainerRegistryEditPageProps extends NSARouterMakerResult, ContainerRegistryRouterProps
{
    isEdit: boolean;
}

export interface ContainerRegistryEditPageState
{
    selected_type: ContainerRegistryType | null;
}

class ContainerRegistryEditPage extends Component<ContainerRegistryEditPageProps, ContainerRegistryEditPageState>
{
    NSBoxString_Name = createRef<NSBoxString>();
    NSBoxEnum_Type = createRef<NSBoxEnum<ContainerRegistryType>>();
    NSBoxEntity_AWSCredentialID = createRef<NSBoxEntity<AWSRow>>();
    NSBoxEntity_AzureCredentialID = createRef<NSBoxEntity<AzureRow>>();
    NSBoxEntity_BasicAuthCredentialID = createRef<NSBoxEntity<BasicAuthRow>>();
    NSBoxEntity_GCPCredentialID = createRef<NSBoxEntity<GCPRow>>();
    NSBoxEntity_GitHubCredentialID = createRef<NSBoxEntity<GitHubRow>>();
    NSBoxEntity_GitLabCredentialID = createRef<NSBoxEntity<GitLabRow>>();
    NSBoxTextArea_Description = createRef<NSBoxTextArea>();

    constructor(props: ContainerRegistryEditPageProps)
    {
        super(props);
        this.state = { selected_type: null }
    }

    override render()
    {
        let namirasoft = new NamirasoftMap(this.props.account.token_manager, console.error);

        return (
            <ContainerRegistryLayout<ContainerRegistryRow, ContainerRegistryRow>
                {...this.props}
                pages={{
                    entity: ContainerRegistryEntities.container_registry(this.props),
                    edit: {
                        ...this.props,
                        ui: {
                            tab_page_edit: {
                                editor: {
                                    getInputRow: (): ContainerRegistryRow =>
                                    {
                                        let name = this.NSBoxString_Name.current?.getValue() ?? "";
                                        let type = this.NSBoxEnum_Type.current?.getValueEnumOne(ContainerRegistryType, ContainerRegistryType.AWSECR) ?? ContainerRegistryType.AWSECR;
                                        let description = this.NSBoxTextArea_Description.current?.getValue() ?? "";

                                        let meta: Record<string, string> | null = null;

                                        if (type === ContainerRegistryType.AWSECR)
                                            meta = { aws_credential_id: this.NSBoxEntity_AWSCredentialID.current?.getValueOne() ?? "" };

                                        else if (type === ContainerRegistryType.AzureACR)
                                            meta = { azure_credential_id: this.NSBoxEntity_AzureCredentialID.current?.getValueOne() ?? "" };

                                        else if (type === ContainerRegistryType.GitHubContainerRegistry)
                                            meta = { git_hub_credential_id: this.NSBoxEntity_GitHubCredentialID.current?.getValueOne() ?? "" };

                                        else if (type === ContainerRegistryType.GitLabContainerRegistry)
                                            meta = { git_lab_credential_id: this.NSBoxEntity_GitLabCredentialID.current?.getValueOne() ?? "" };

                                        else if (type === ContainerRegistryType.GoogleArtifactRegistry || type === ContainerRegistryType.GoogleContainerRegistry)
                                            meta = { gcp_credential_id: this.NSBoxEntity_GCPCredentialID.current?.getValueOne() ?? "" };

                                        else if (type === ContainerRegistryType.PrivateRegistry)
                                            meta = { basic_auth_credential_id: this.NSBoxEntity_BasicAuthCredentialID.current?.getValueOne() ?? "" };

                                        return {
                                            id: '',
                                            user_id: '',
                                            workspace_id: '',

                                            name,
                                            type,
                                            meta,
                                            description,

                                            created_at: new Date(),
                                            updated_at: new Date()
                                        }
                                    },
                                    setRow: (row: ContainerRegistryRow) =>
                                    {
                                        this.NSBoxString_Name.current?.setValue(row.name);
                                        this.NSBoxEnum_Type.current?.setValue(row.type);
                                        this.NSBoxTextArea_Description.current?.setValue(row.description);

                                        this.setState(() => ({ selected_type: row.type }), () =>
                                        {
                                            if (row.type === ContainerRegistryType.AWSECR)
                                                this.NSBoxEntity_AWSCredentialID.current?.setValueOne(row.meta.aws_credential_id);

                                            else if (row.type === ContainerRegistryType.AzureACR)
                                                this.NSBoxEntity_AzureCredentialID.current?.setValueOne(row.meta.azure_credential_id);

                                            else if (row.type === ContainerRegistryType.GitHubContainerRegistry)
                                                this.NSBoxEntity_GitHubCredentialID.current?.setValueOne(row.meta.git_hub_credential_id);

                                            else if (row.type === ContainerRegistryType.GitLabContainerRegistry)
                                                this.NSBoxEntity_GitLabCredentialID.current?.setValueOne(row.meta.git_lab_credential_id);

                                            else if (row.type === ContainerRegistryType.GoogleArtifactRegistry || row.type === ContainerRegistryType.GoogleContainerRegistry)
                                                this.NSBoxEntity_GCPCredentialID.current?.setValueOne(row.meta.gcp_credential_id);

                                            else if (row.type === ContainerRegistryType.PrivateRegistry)
                                                this.NSBoxEntity_BasicAuthCredentialID.current?.setValueOne(row.meta.basic_auth_credential_id);
                                        });
                                    }
                                },
                            }
                        }
                    }
                }}
            >
                <NSColumn>
                    <NSRow>
                        <NSBoxString
                            ref={this.NSBoxString_Name}
                            title="Name"
                            required
                        />
                        <NSBoxEnum<ContainerRegistryType>
                            ref={this.NSBoxEnum_Type}
                            title="Type"
                            required
                            multiple={false}
                            getEnumObject={() => ContainerRegistryType}
                            getTitle={(value) => NamingConvention.auto.convert(value, NamingConvention.Pascal_Case_Space)}
                            onChanged={(box) =>
                            {
                                this.setState(() => ({ selected_type: (box.getValue() as ContainerRegistryType) ?? null }));
                            }}
                        />
                    </NSRow>
                    {
                        this.state.selected_type === ContainerRegistryType.AWSECR &&
                        <NSBoxEntity<AWSRow>
                            ref={this.NSBoxEntity_AWSCredentialID}
                            title="AWS Credential ID"
                            required
                            multiple={false}
                            table={namirasoft.credential.tables.aws}
                            getValue={(item) => item.id}
                            getTitle={(item) => item.name}
                            getSort={() => null}
                            style={{ width: NSBox.width.double }}
                        />
                    }
                    {
                        this.state.selected_type === ContainerRegistryType.AzureACR &&
                        <NSBoxEntity<AzureRow>
                            ref={this.NSBoxEntity_AzureCredentialID}
                            title="Azure Credential ID"
                            required
                            multiple={false}
                            table={namirasoft.credential.tables.azure}
                            getValue={(item) => item.id}
                            getTitle={(item) => item.name}
                            getSort={() => null}
                            style={{ width: NSBox.width.double }}
                        />
                    }
                    {
                        this.state.selected_type === ContainerRegistryType.GitHubContainerRegistry &&
                        <NSBoxEntity<GitHubRow>
                            ref={this.NSBoxEntity_GitHubCredentialID}
                            title="GitHub Credential ID"
                            required
                            multiple={false}
                            table={namirasoft.credential.tables.git_hub}
                            getValue={(item) => item.id}
                            getTitle={(item) => item.name}
                            getSort={() => null}
                            style={{ width: NSBox.width.double }}
                        />
                    }
                    {
                        this.state.selected_type === ContainerRegistryType.GitLabContainerRegistry &&
                        <NSBoxEntity<GitLabRow>
                            ref={this.NSBoxEntity_GitLabCredentialID}
                            title="GitLab Credential ID"
                            required
                            multiple={false}
                            table={namirasoft.credential.tables.git_lab}
                            getValue={(item) => item.id}
                            getTitle={(item) => item.name}
                            getSort={() => null}
                            style={{ width: NSBox.width.double }}
                        />
                    }
                    {
                        (this.state.selected_type === ContainerRegistryType.GoogleArtifactRegistry || this.state.selected_type === ContainerRegistryType.GoogleContainerRegistry) &&
                        <NSBoxEntity<GCPRow>
                            ref={this.NSBoxEntity_GCPCredentialID}
                            title="GCP Credential ID"
                            required
                            multiple={false}
                            table={namirasoft.credential.tables.gcp}
                            getValue={(item) => item.id}
                            getTitle={(item) => item.name}
                            getSort={() => null}
                            style={{ width: NSBox.width.double }}
                        />
                    }
                    {
                        this.state.selected_type === ContainerRegistryType.PrivateRegistry &&
                        <NSBoxEntity<BasicAuthRow>
                            ref={this.NSBoxEntity_BasicAuthCredentialID}
                            title="Basic Auth Credential ID"
                            required
                            multiple={false}
                            table={namirasoft.credential.tables.basic_auth}
                            getValue={(item) => item.id}
                            getTitle={(item) => item.name}
                            getSort={() => null}
                            style={{ width: NSBox.width.double }}
                        />
                    }
                    <NSBoxTextArea
                        ref={this.NSBoxTextArea_Description}
                        title="Description"
                        required={false}
                        style={{ width: NSBox.width.double }}
                    />
                </NSColumn>
            </ ContainerRegistryLayout>
        )
    }
}
export default ContainerRegistryEditPage;